import { Typography } from '@mui/material';
import { Translation } from 'react-i18next';
import { ProfileEditorWrapper } from '../common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ShippingInfoBox = function ShippingInfoBox(_ref) {
  var questionRef = _ref.questionRef,
      _children = _ref.children;
  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "ShippingInfoBox",
    "data-source-file": "shipping-info-box.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsxs(ProfileEditorWrapper, {
        ref: questionRef,
        children: [/*#__PURE__*/_jsx(Typography, {
          sx: {
            mb: 1
          },
          variant: "h2",
          children: t('Shipping information')
        }), /*#__PURE__*/_jsx(Typography, {
          sx: {
            mb: 3
          },
          variant: "body2",
          children: t('Rewards you redeem will be sent to the shipping address below')
        }), _children]
      });
    }
  });
};